module.exports = __webpack_public_path__ + "static/media/SourceCodePro-Regular.b484b32f.ttf";